import {
  FARMER_PAGE_INFORMATION_ERROR,
  FARMER_PAGE_INFORMATION_SUCCESS,
  SAVE_CHANGES_TO_FARMER_PAGE_SUCCESS,
  SAVE_CHANGES_TO_FARMER_PAGE_ERROR,
} from '../containers/Admin/AboutYouPage/types.js';

/** Store states
 * @constant {Object} */
export const initialState = {
  farmerPageDetails: {},
  errorMessage: '',
  isLatestSaveSuccessful: false,
  saveChangesErrorMessage: '',
};

/** Tell me more page reducer.
 * @param {Object} state - Initial state
 * @param {Object} action - Payload object
 * @return {Object} - return new state
 */
function farmerReducer(state = initialState, action) {
  switch (action.type) {
    case FARMER_PAGE_INFORMATION_SUCCESS:
      return {
        ...state,
        farmerPageDetails: action.payload,
        errorMessage: '',
      };
    case FARMER_PAGE_INFORMATION_ERROR:
      return {
        ...state,
        farmerPageDetails: {},
        errorMessage: action.payload,
      };
    case SAVE_CHANGES_TO_FARMER_PAGE_SUCCESS:
      return {
        ...state,
        isLatestSaveSuccessful: true,
        saveChangesErrorMessage: '',
      };
    case SAVE_CHANGES_TO_FARMER_PAGE_ERROR:
      return {
        ...state,
        isLatestSaveSuccessful: false,
        saveChangesErrorMessage: action.payload,
      };

    default:
      return state;
  }
}

export default farmerReducer;
